import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, injectIntl } from 'react-intl';
import { getFirstSupportedLocale, IntlErrorBoundary } from '@ti8m/paas-ui';

import translations from './translations';

import App from './App';

const locale = getFirstSupportedLocale(translations, 'de-CH', true);
const msgs = translations[locale.substring(0, 2)];

const ErrorBoundary = injectIntl(IntlErrorBoundary as React.FunctionComponent);

ReactDOM.render(
  <IntlProvider locale={locale} defaultLocale="de-CH" messages={msgs}>
    <ErrorBoundary>
      <App locale={locale} />
    </ErrorBoundary>
  </IntlProvider>,
  document.getElementById(process.env.REACT_APP_PORTLET_NAME || 'search'),
);
